
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useBusinessOwner(businessId?: string) {
  return useQuery({
    queryKey: ['business-owner', businessId],
    queryFn: async () => {
      if (!businessId) return null;
      
      const { data, error } = await supabase
        .from('businesses')
        .select('user_id')
        .eq('id', businessId)
        .single();
      
      if (error) throw error;
      return data?.user_id || null;
    },
    enabled: !!businessId
  });
}
